export default __webpack_public_path__ + "static/media/signupImage2.2d513bb3.webp";